import { Suspense } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { DeliveryDateAsync } from './DeliveryDateAsync';
import { DeliveryDateSkeleton } from './DeliveryDateSkeleton';
import type { DeliveryDateAsyncProps } from './types';

/**
 * Component for streaming delivery date display
 *
 * Two-layer error handling:
 * - ErrorBoundary: catches thrown errors from DeliveryDateAsync
 * - Suspense: shows skeleton during streaming
 *
 * Both layers use the same skeleton fallback for consistent UI.
 *
 * Pattern: ErrorBoundary > Suspense > AsyncComponent
 */
export function DeliveryDateStream(props: DeliveryDateAsyncProps) {
  return (
    <ErrorBoundary fallback={<DeliveryDateSkeleton />}>
      <Suspense fallback={<DeliveryDateSkeleton />}>
        <DeliveryDateAsync {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
